module.exports = __webpack_public_path__ + "static/img/burguer-color.b363b37.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/burguer-color.gif
// module id = ZtKP
// module chunks = 4